import { can } from '@esentai/core/policy-dsl';

import { VIEW_NAVIGATION_BAR } from '@/features/currentUser/permissions/consts/permissions';
import { authorizeIf } from '@/features/currentUser/rbac';

export const canViewHeader = authorizeIf(can(VIEW_NAVIGATION_BAR));
